import Img1 from './1.png';
import Img2 from './2.png';
import Img3 from './3.png';
import Img4 from './4.png';
import Img5 from './5.png';
import Img6 from './6.png';
import Img7 from './7.png';
import Img8 from './8.png';
import Img9 from './9.png';
import Img10 from './10.png';
import Img11 from './11.png';
import Img12 from './12.png';
import Img13 from './13.png';
import Img14 from './14.png';
import Img15 from './15.png';
import Img16 from './16.png';
import { LOGO_INVITATO } from '@/constants/assets'

export const SUPPORT_VENDORS = [
  {
    title: '',
    imgUrl: LOGO_INVITATO,
  },
  {
    title: '',
    imgUrl: Img1,
  },
  {
    title: '',
    imgUrl: Img2,
  },
  {
    title: '',
    imgUrl: Img3,
  },
  {
    title: '',
    imgUrl: Img4,
  },
  {
    title: '',
    imgUrl: Img5,
  },
  {
    title: '',
    imgUrl: Img6,
  },
  {
    title: '',
    imgUrl: Img7,
  },
  {
    title: '',
    imgUrl: Img8,
  },
  {
    title: '',
    imgUrl: Img9,
  },
  {
    title: '',
    imgUrl: Img10,
  },
  {
    title: '',
    imgUrl: Img11,
  },
  {
    title: '',
    imgUrl: Img12,
  },
  {
    title: '',
    imgUrl: Img13,
  },
  {
    title: '',
    imgUrl: Img14
  },
  {
    title: '',
    imgUrl: Img15,
  },
  {
    title: '',
    imgUrl: Img16,
  }
]